import '../styles/footer.scss';
import whatsappIcon from '../assets/whatsapp.svg';
import linkedinIcon from '../assets/linkedin.svg';
import instagramIcon from '../assets/instagram.svg';
import logoBlack from '../assets/logo-black.svg';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEnvelope } from '@fortawesome/free-solid-svg-icons';
import { faPhone } from '@fortawesome/free-solid-svg-icons';

export const Footer = () => {
  return (
    <div className='footer'>
      <div className='footer-container'>
        <div className='footer-content'>
          <div className='f-contact'>
            <p>
              <FontAwesomeIcon icon={faEnvelope} className="icon" />
              <a href="mailto:hola@serendipiaconsultora.com">hola@serendipiaconsultora.com</a>
            </p>
            <p>
              <FontAwesomeIcon icon={faPhone} className="icon" />
              <a href="tel:+541155811953">+54 11-5581-1953</a>
            </p>
          </div>
          <div className='f-logo'>
            <img src={logoBlack} alt="Logo" className="logoIcon" />
          </div>
          <div className='f-links'>
            <a href="/nosotros">Nosotros</a>
            <a href="/busquedas">Búsquedas</a>
            <a href="/university">University</a>
          </div>
        </div>
        <div className='social-network'>
          <div className='icons-container'>
            <a href="https://wa.me/5491155811953" target="_blank" rel="noopener noreferrer">
              <img src={whatsappIcon} alt="WhatsApp" className="whatsappIcon" />
            </a>
            <a href="https://www.linkedin.com/company/serendipia-consultora/" target="_blank" rel="noopener noreferrer">
              <img src={linkedinIcon} alt="LinkedIn" className="linkedinIcon" />
            </a>
            <span>|</span>
            <a href="https://www.instagram.com/serendipia.consultora/" target="_blank" rel="noopener noreferrer">
              <img src={instagramIcon} alt="Instagram" className="instagramIcon" />
            </a>
          </div>
        </div>
      </div>
      <div className='rights'>
        <p>© Copyright 2025 | Serendipia Consultora | Todos los derechos reservados.</p>
      </div>
    </div>
  )
}
